import { Grid } from "@mui/material";
import Sidebar from "./filter";
import OrdersList from "./order_list";

function Summary() {
  return (
    <Grid container spacing={3} mt={2}>
      <Grid item xs={12} sm={12} md={3}>
        <Sidebar />
      </Grid>
      <Grid item xs={12} sm={12} md={9}>
        <OrdersList />
      </Grid>
    </Grid>
  );
}
export default Summary;
